import React from "react";
import { fieldGenerator, getErrorOnField } from "utilities/form";
import { Form } from "antd";
import { INPUT_TYPES } from "constants/input-types";
import PropTypes from "prop-types";
import cx from "classnames";
import { OrderedMap } from "immutable";
import "styles/form.css";

const addUserForm = new OrderedMap({
    first_name: {
        type: INPUT_TYPES.TEXT,
        label: "First Name",
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ],
        className: "form-field fb-33"
    },
    middle_name: {
        type: INPUT_TYPES.TEXT,
        label: "Middle Name",
        className: "form-field fb-33"
    },
    last_name: {
        type: INPUT_TYPES.TEXT,
        label: "Last Name",
        className: "form-field fb-33",
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ]
    },
    email: {
        type: INPUT_TYPES.TEXT,
        label: "Email Id",
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ]
    },
    group: {
        type: INPUT_TYPES.SELECT,
        label: "Assign Group",
        options: [],
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ]
    }
});

class AddUserForm extends React.Component {
    fieldGenerator = fieldGenerator.bind(this.props.form);
    getErrorOnField = getErrorOnField.bind(this.props.form);

    render() {
        return (
            <Form className={cx("form", "br-3")}>
                <div className={"form-row"}>
                    {addUserForm
                        .map((field, fieldName) =>
                            this.fieldGenerator(
                                fieldName,
                                field,
                                this.getErrorOnField(fieldName)
                            )()
                        )
                        .toList()}
                </div>
            </Form>
        );
    }
}

AddUserForm.propTypes = {
    form: PropTypes.object
};

export default Form.create({})(AddUserForm);
